export const URL_PARAMETER = {
  URL_NAME: 'urlName',
  PLACE_ID: 'placeId',
  URL_NAME_OR_REVIEW_UUID: 'urlNameOrReviewUuid',
  APPOINTMENT_ID: 'appointmentId',
  BOOKING_UUID: 'bookingUuid',
  QR_CODE: 'qrCode',
  CITY: 'city',
};

// WARN: If there is new route group, it should be configured in GTM Trigger (in "My custom page view trigger")
export const ROUTE_PATH = {
  // public
  HOME: 'home',
  SALON_SEARCH_RESULT: 'salon',
  SALON_DETAILS: `salon/:${URL_PARAMETER.URL_NAME}`,
  SALON_BOOKING_CONFIG: `salon/:${URL_PARAMETER.URL_NAME}/booking`,
  PUBLIC_APPOINTMENT_DETAILS: `booking/:${URL_PARAMETER.BOOKING_UUID}`,
  GOOGLE_SALON_DETAILS: `salon-around/:${URL_PARAMETER.PLACE_ID}`,
  RWG_CANCEL_REQUEST: `google-integration-cancel-request`,
  IMPRINT: 'imprint',
  PRIVACY_POLICY: 'privacy-policy',
  TOP_SALONS: 'top-salons',
  TOP_SALONS_CITY: `top-salons/:${URL_PARAMETER.CITY}`,

  // public - redirect link
  REDIRECT_LINK: 'link', // root path
  BOOKING_DIRECT_LINK: `booking/:${URL_PARAMETER.BOOKING_UUID}`,
  QR_CHECKIN_LINK: `qr-checkin/:${URL_PARAMETER.QR_CODE}`,

  // public - auth process
  AUTH_PROCESS: 'auth', // root path
  LOGIN: 'login',
  LOGIN_SECRET_WITH_PIN: 'login/pin',
  LOGIN_SECRET_WITH_PASSWORD: 'login/password',
  REGISTRATION_PERSONAL_DATA: 'registration',
  REGISTRATION_SECRET_DATA: 'registration-secret',
  REGISTRATION_PIN: 'registration-pin',
  REGISTRATION_SUCCESS: 'registration-success',

  // public - feedback process
  FEEDBACK_PROCESS: 'feedback', // root path
  FEEDBACK_EMOTION: `:${URL_PARAMETER.URL_NAME_OR_REVIEW_UUID}`,
  FEEDBACK_INTERNAL_DETAILS: `:${URL_PARAMETER.URL_NAME_OR_REVIEW_UUID}/details`,
  FEEDBACK_INTERNAL_SUCCESS: `:${URL_PARAMETER.URL_NAME}/success`,

  // private
  PRIVATE: 'me', // root path
  SALON_VISITED: 'salon',
  QR_CHECKIN_CONFIG: `salon/:${URL_PARAMETER.URL_NAME}/checkin`,
  QR_CHECKIN_SUCCESS: `salon/:${URL_PARAMETER.URL_NAME}/checkin-success`,
  APPOINTMENT_HISTORY: 'booking',
  APPOINTMENT_DETAILS: `booking/:${URL_PARAMETER.APPOINTMENT_ID}`,
  USER_PROFILE: 'profile',
};
